import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, unref as _unref, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("i", { class: "material-icons" }, "add", -1)
const _hoisted_2 = { class: "modal-content p-d-flex p-flex-column gap-20 p-pt-3" }
const _hoisted_3 = { class: "flexbox-row" }

import { reactive, ref } from 'vue';
import PadelInput from '@/widgets/input/PadelInput.vue';
import UiButton from '../ui/UiButton.vue';
import { useI18n } from 'vue-i18n';
import { showSuccessToast, showToast } from '@/services/error-management.service';
import { useStore } from '@/store/store';
import { client } from '@/api/client-v2';
import { object, string } from 'yup';


export default _defineComponent({
  emits: ['updated'],
  setup(__props, { emit }) {

const { t } = useI18n();
const store = useStore();

const isVisible = ref(false);


const form = reactive({
  email: '',
  firstName: '',
  lastName: '',
  phone: '',
})

const errors = reactive({
  email: '',
  firstName: '',
  lastName: '',
  phone: '',
})

const schema = object({
  firstName: string().required(t('required_field')),
  lastName: string().required(t('required_field')),
  email: string().required(t('required_field')).email(t('valid_email_error')),
  phone: string()
    .required(t('required_field'))
    .matches(/^[0-9]{6,14}$/, t('number_not_valid')),
});

const resetForm = () => {
  form.email = '';
  form.firstName = '';
  form.lastName = '';
  form.phone = '';
  Object.keys(errors).forEach(key => errors[key] = '');
}

const validate = async () => {
  try {
    await schema.validate(form, { abortEarly: false });
    Object.keys(errors).forEach(key => errors[key] = '');
    return true;
  } catch (err: any) {
    Object.keys(errors).forEach(key => errors[key] = '');
    err.inner.forEach((error: any) => {
      if (error.path) errors[error.path] = error.message;
    });
    return false;
  }
}

const submit = async () => {
  const isValid = await validate();
  if (!isValid) return;
  isVisible.value = false;
  try {
    await client.addManager({ ...form, clubId: store.getters.getMyClub.club_id });
    showSuccessToast('Manager aggiunto con successo');
    resetForm();
    emit('updated');
  } catch (error) {
    showToast('Errore durante l\'aggiunta del manager');
  }
}

return (_ctx: any,_cache: any) => {
  const _component_DumbModal = _resolveComponent("DumbModal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(UiButton, {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (isVisible.value = true)),
      label: "Aggiungi Manager"
    }, {
      "right-icon": _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    (isVisible.value)
      ? (_openBlock(), _createBlock(_component_DumbModal, {
          key: 0,
          onHide: _cache[7] || (_cache[7] = () => isVisible.value = false),
          title: "Aggiungi Manager"
        }, {
          footer: _withCtx(() => [
            _createVNode("div", _hoisted_3, [
              _createVNode(UiButton, {
                onClick: _cache[6] || (_cache[6] = () => isVisible.value = false),
                "is-text": "",
                size: "lg",
                class: "uppercase"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('abort')), 1)
                ]),
                _: 1
              }),
              _createVNode(UiButton, {
                onClick: submit,
                size: "lg",
                class: "p-ml-auto uppercase"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('save')), 1)
                ]),
                _: 1
              })
            ])
          ]),
          default: _withCtx(() => [
            _createVNode("div", _hoisted_2, [
              _createVNode("form", {
                onSubmit: _withModifiers(submit, ["prevent"]),
                class: "flexbox-column gap-20"
              }, [
                _createVNode(PadelInput, {
                  label: _unref(t)('name'),
                  value: _unref(form).firstName,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_unref(form).firstName = $event)),
                  error: _unref(errors).firstName
                }, null, 8, ["label", "value", "error"]),
                _createVNode(PadelInput, {
                  label: _unref(t)('surname'),
                  value: _unref(form).lastName,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (_unref(form).lastName = $event)),
                  error: _unref(errors).lastName
                }, null, 8, ["label", "value", "error"]),
                _createVNode(PadelInput, {
                  label: _unref(t)('email'),
                  value: _unref(form).email,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (_unref(form).email = $event)),
                  error: _unref(errors).email
                }, null, 8, ["label", "value", "error"]),
                _createVNode(PadelInput, {
                  label: _unref(t)('phonenumber'),
                  value: _unref(form).phone,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => (_unref(form).phone = $event)),
                  error: _unref(errors).phone
                }, null, 8, ["label", "value", "error"])
              ], 40, ["onSubmit"])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})